// v2/hooks/useMenuNav.js — header/menu yonlendirmeleri tek yerden
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth';

/** Hazir sayfalar: menu id -> rota */
const ROUTES = {
  home:     '/v2',
  products: '/v2/products',
  cart:     '/v2/cart',
  checkout: '/v2/cart',
  account:  '/v2/account',
  balance:  '/v2/debt',
  orders:   '/v2/orders',
  quotes:   '/v2/quotes',
  debt:     '/v2/debt',
  invoices: '/v2/debt',
};

/** Dis siteye giden menuler: menu id -> adres (yeni sekmede acilir) */
const DIS_BAGLANTI = {
  payment: 'https://www.bosch-tahsilat.com/',
};

/** Henuz sayfasi olmayanlar: menu id -> kullaniciya gosterilecek ad */
const PENDING = {
  ai:       'Yapay Zekâya Sor',
};

/**
 * Header, MobileNav ve kullanici menusundeki tum tiklamalari yonetir.
 * @param {(msg: string, type?: string) => void} [notify] toast.push gibi bir fonksiyon
 */
export default function useMenuNav(notify) {
  const navigate = useNavigate();
  const { cikisYap } = useAuth();

  return useCallback((id) => {
    const to = ROUTES[id];
    if (to) { navigate(to); return; }

    const dis = DIS_BAGLANTI[id];
    if (dis) {
      window.open(dis, '_blank', 'noopener,noreferrer');
      return;
    }

    if (id === 'logout') {
      // Token sunucuda iptal edilir, yerel oturum silinir, /login'e tam yenilemeyle gidilir.
      // ("Beni hatirla" bilgisi korunur; sadece formu doldurur, otomatik giris yapmaz.)
      cikisYap();
      return;
    }

    const label = PENDING[id];
    if (label && typeof notify === 'function') {
      notify(`${label} sayfası yakında eklenecek.`, 'info');
    }
  }, [navigate, notify, cikisYap]);
}
